import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=132c7a1b&scoped=true&"
import script from "./Registration.vue?vue&type=script&lang=js&"
export * from "./Registration.vue?vue&type=script&lang=js&"
import style0 from "./Registration.vue?vue&type=style&index=0&id=132c7a1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132c7a1b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SocialLogin: require('/home/bitrix/frontend/components/forms/SocialLogin.vue').default,RegistrationForm: require('/home/bitrix/frontend/components/forms/RegistrationForm.vue').default})
